import { CURRENT_HIGH_SCORE_VERSION, migrateHighScores } from './migrate.ts';
import type { HighScoreDocument } from './types.ts';

export function serializeHighScores(document: HighScoreDocument): string {
  return JSON.stringify({ ...document, version: CURRENT_HIGH_SCORE_VERSION });
}

export function parseHighScores(json: string): HighScoreDocument | null {
  let parsed: unknown;

  try {
    parsed = JSON.parse(json);
  } catch {
    return null;
  }

  return migrateHighScores(parsed);
}

export function isHighScoreDocument(value: unknown): boolean {
  return migrateHighScores(value) !== null;
}
